import { createSlice } from "@reduxjs/toolkit";
import { loginAPI, logoutAPI } from "../../services/login";
import { STATUS_CODE } from "../../common";
import { setItem } from "../../common/localStorage";
import { clearGuestSessionStorage } from "../../common/authSession";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const logoutSlice = createSlice({
  name: "logoutSliceDetails",
  initialState: data,
  reducers: {
    logoutSliceInfo(state) {
      state.isLoading = true;
    },
    logoutSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    logoutSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    logoutSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const logoutHandler = (data) => async (dispatch) => {
  try {
    dispatch(logoutSliceAction.logoutSliceInfo());
    const response = await logoutAPI(data);
    if(response?.statusCode === STATUS_CODE.OK){
      clearGuestSessionStorage();
    }
    dispatch(logoutSliceAction.logoutSliceSuccess(response));
  } catch (e) {
    dispatch(logoutSliceAction.logoutSliceFailure(e));
  }
};
export default logoutSlice.reducer;
export const logoutSliceAction = logoutSlice.actions;
